import React, { useEffect, useRef, useState } from "react";
import FarmReportContainer from "./FarmReport";
import { urls } from "../../services/apiService";
import ImageEditor from "./placemarks";
import { Home, Droplet, LandPlot, WaypointsIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import AgronomistInputContainer from "./AgronomistInputContainer";

const ReportVisualization = () => {
  const reportRef = useRef();
  const [cleanedReportData, setCleanedReportData] = useState([]);
  const [date, setDate] = useState("");
  const [recommend, setRecommend] = useState("");
  const [field2, setField2] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [name, setName] = useState({ fieldName: "Report" }); // Default name
  const [uploadedImage, setUploadedImage] = useState(null); // State for uploaded image
  const [isLoading, setIsLoading] = useState(false);
  const [anotherImage, setAnotherImage] = useState(null);
  const [previewURL, setPreviewURL] = useState(null);
  const [forecast, setForecast] = useState(null);
  const { t, i18n } = useTranslation();
  
  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setAnotherImage(file);

      const reader = new FileReader();
      reader.readAsDataURL(file); // Convert image to Base64
      reader.onloadend = () => {
        setPreviewURL(reader.result); // Store Base64 string
      };
    }
  };

  const [weather, setWeather] = useState({
    dewpoint: null,
    feelslike: null,
    wind_kph: null,
    humidity: null,
    preceip_mm: null,
    temp_C: null,
  });

  useEffect(() => {
    const savedRecords = localStorage.getItem("record");
    const savedDates = localStorage.getItem("date");
    const Fieldname = localStorage.getItem("report");
    const Weather_Data = localStorage.getItem("Weather_Data");
    const forecast_Data = localStorage.getItem("forecast");

    if (savedRecords && savedDates && Fieldname && Weather_Data) {
      const parsedRecords = JSON.parse(savedRecords).combined;
      const parsedDates = JSON.parse(savedDates);
      const parsedData = JSON.parse(Fieldname);
      const parsedWeather_Data = JSON.parse(Weather_Data);
      const parsedforecast_Data = JSON.parse(forecast_Data);

      setName({
        fieldName: parsedData?.fieldName || "Default_Report",
      });

      if (parsedDates.a) {
        const cleanedData = parsedRecords.map((urlss) =>
          urlss.map((url) => url.replace("mysite/", urls.base))
        );
        console.log("to see images: ", cleanedData);
        console.log("to see dates: ", parsedDates);
        // ✅ Calculate dew point if missing
        const calculateDewPoint = (tempC, humidity) => {
          if (tempC == null || humidity == null) return null;
          const a = 17.27;
          const b = 237.7;
          const alpha = (a * tempC) / (b + tempC) + Math.log(humidity / 100);
          return (b * alpha) / (a - alpha);
        };

        const humidity =
          parsedWeather_Data?.humidity ?? parsedWeather_Data?.avghumidity;
        const tempC =
          parsedWeather_Data?.temp_C ?? parsedWeather_Data?.avgtemp_c;
        const dewpoint =
          parsedWeather_Data?.dewpoint_c ?? calculateDewPoint(tempC, humidity);

        setCleanedReportData(cleanedData);
        setWeather({
          dewpoint: dewpoint ? parseFloat(dewpoint.toFixed(1)) : "N/A",
          feelslike: parsedWeather_Data?.feelslike_c ?? parsedWeather_Data?.avgtemp_c,
          wind_kph:
            parsedWeather_Data?.wind_kph ?? parsedWeather_Data?.maxwind_kph,
          humidity: humidity,
          preceip_mm:
            parsedWeather_Data?.totalprecip_mm ?? parsedWeather_Data?.precip_mm,
          temp_C: tempC,
        });

        setDate(parsedDates);
        setForecast(parsedforecast_Data);

      } else {
        console.warn("Date A is required.");
      }
    }
  }, []);

  const fetchBaseAreaImage = async () => {
    try {
      const reportData = JSON.parse(localStorage.getItem("report"));
      const fieldName = reportData?.fieldName;
      if (!fieldName) return;

      const res = await fetch(urls.baseAreaImage, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ fieldName }),
      });

      const data = await res.json();
      setUploadedImage(data.success ? data.image_url : null);
      console.log("Base Area Image URL:", data);
    } catch (error) {
      console.error("Error fetching image:", error);
      setUploadedImage(null);
    }
  };


  const handleDownloadPDF = async () => {
    setIsLoading(true); // Start loader
    const element = reportRef.current;
    if (!element) {
      console.error("Element not found!");
      return;
    }

    try {
      // Generate HTML content from the DOM
      let htmlContent;

      if (i18n.language === "ur") {
        htmlContent = `
  <!DOCTYPE html>
  <html lang="ur">
    <head>
      <meta charset="UTF-8" />
      <title>${name.fieldName || "Report"}</title>
      <link href="https://fonts.googleapis.com/css2?family=Noto+Naskh+Arabic&display=swap" rel="stylesheet">
      <style>
        body {
          font-family: 'Noto Naskh Arabic', sans-serif;
          direction: rtl;
          font-size: 16px;
          color: #374151;
          margin: 0;
          padding: 20px;
        }
      </style>
    </head>
    <body>
      ${element.outerHTML}
    </body>
  </html>
  `;
      } else {
        // ✅ Use a mixed font stack to render both English & Urdu properly
        htmlContent = `
  <!DOCTYPE html>
  <html lang="en">
    <head>
      <meta charset="UTF-8" />
      <title>${name.fieldName || "Report"}</title>
      <link href="https://fonts.googleapis.com/css2?family=Noto+Sans&family=Noto+Naskh+Arabic&display=swap" rel="stylesheet">
      <style>
        body {
          font-family: 'Noto Sans', 'Noto Naskh Arabic', sans-serif;
          direction: ltr;
          font-size: 16px;
          color: #374151;
          margin: 0;
          padding: 20px;
        }
        /* Optional: force Urdu text blocks to display RTL */
        [lang="ur"], .urdu-text {
          direction: rtl;
          font-family: 'Noto Naskh Arabic', sans-serif;
        }
      </style>
    </head>
    <body>
      ${element.outerHTML}
    </body>
  </html>
  `;
      }
      // Send the HTML content to the server
      const response = await fetch(urls.pDF, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/pdf"
        },
        body: JSON.stringify({
          title: name.fieldName || "Report", // Pass the filename
          htmlContent,
          previewURL,

        }),
      });

      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `${name.fieldName}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        console.error("Failed to generate PDF");
      }
    } catch (error) {
      console.error("Error during PDF download:", error);
    }
    finally {
      setIsLoading(false); // Stop loader
    }
  };

  const data =
    cleanedReportData.length > 0 && cleanedReportData[0]?.length > 0
      ? cleanedReportData[0].map((_, idx) => {
        const indexDetails = [
          {
            title: t("Crop Health "),
            description: i18n.language === "ur"
              ? "پودوں کی صحت کی نشاندہی کرتا ہے۔"
              : "Indicates the health of vegetation.",

            levels: i18n.language === "ur"
              ? ["ناقص", "کم", "درمیانہ", "اچھا", "بہترین"]
              : ["Poor", "Low", "Moderate", "Good", "Best"],

            colors: ['#FF0000', '#FF8000', '#FFF000', '#8DD400', '#38A800'],
          },
          {
            title: t("Moisture Content"),
            description: i18n.language === "ur"
              ? "پودوں میں نمی کی مقدار بتاتا ہے۔"
              : "Measures the moisture content in vegetation.",

            levels: i18n.language === "ur"
              ? ["کم", "درمیانہ", "زیادہ", "انتہائی زیادہ"]
              : ["Low", "Medium", "High", "Very High"],

            colors: ['#BFE9FF', '#40A0FF', '#0053D0', '#002673'],
          },
          {
            title: t("Germination & Initial Growth"),
            description: i18n.language === "ur"
              ? "زمین کے ظاہر ہونے والے علاقوں میں این ڈی وی آئی کو بہتر بناتا ہے۔"
              : "Improves NDVI in areas with soil exposure.",

            levels: i18n.language === "ur"
              ? ["ناقص", "انکرت", "درمیانہ", "اچھا", "بہترین"]
              : ["Poor", "Sprouts", "Moderate", "Good", "Best"],

            colors: ['#61150D', '#A47F3E', '#B1BA5A', '#6F8B3A', '#104510'],
          },
          {
            title: t("Fertilizer Content"),
            description: i18n.language === "ur"
              ? "فصل کی صحت اور کھاد کا اندازہ لگانے کے لیے مفید"
              : "Useful for assessing crop health and fertilizer content.",

            levels: i18n.language === "ur"
              ? ["ناقص", "درمیانہ", "اچھا", "بہترین"]
              : ["Poor", "Moderate", "Good", "Best"],

            colors: ['#DCF5E9', '#8BBA98', "#4B885A", '#226633'],
          },
          {
            title: t("Natural Image"),
            description: i18n.language === "ur"
              ? "حقیقی رنگ کی مرکب امیجری کی نمائندگی کرتا ہے۔"
              : "Represents true color composite imagery.",
            levels: [],
            colors: [],
          },
        ];

        const details = indexDetails[idx] || {};
        
        // Updated logic for title generation
        let title;
        if (date.b) {
          // Both dates exist - show comparison
          title = i18n.language === "ur"
            ? `${details.title}: ${date.b} بمقابلہ ${date.a}`
            : `${details.title}: ${date.b} vs ${date.a}`;
        } else {
          // Only date.a exists - show single date report
          title = i18n.language === "ur"
            ? `${details.title}: ${date.a} کی رپورٹ`
            : `${details.title}: Report for ${date.a}`;
        }

        const description = details.description;
        const levels = details.levels;
        const colors = details.colors;
        
        // Updated logic for images
        const images = [];
        
        if (date.b && cleanedReportData[1]?.[idx]) {
          // Both dates exist - show both images
          images.push(
            { label: date.b, url: cleanedReportData[1][idx] || "" },
            { label: date.a, url: cleanedReportData[0]?.[idx] }
          );
        } else {
          // Only date.a exists - show only the first image
          images.push(
            { label: date.a, url: cleanedReportData[0]?.[idx] }
          );
        }

        return {
          title,
          description,
          levels,
          colors,
          images,
        };
      })
      : [];

  useEffect(() => {
    fetchBaseAreaImage();
  }, [uploadedImage,isModalOpen]);


  // Open modal logic
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  
  return (
    <div className="w-full p-4 flex flex-col items-center overflow-x-auto sm:overflow-y-auto">
      {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 p-4">
          <div className="bg-white w-[90%] sm:max-w-lg md:max-w-xl lg:max-w-2xl p-6 rounded-lg shadow-lg max-h-[80vh] overflow-y-auto">

            <h2 className="text-lg font-bold mb-4 text-gray-800">{t("Enter Details")}</h2>

            {/* Recommendation Input */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">
                {t("Recommendation:")}
              </label>
              <input
                type="text"
                className="w-full p-2 mt-1 border rounded-md focus:ring focus:ring-blue-200"
                value={recommend}
                onChange={(e) => setRecommend(e.target.value)}
                placeholder={t("Enter recommendation...")}
              />
            </div>

            {/* Additional Field Input */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">
                {t("Additional Field:")}
              </label>
              <input
                type="text"
                className="w-full p-2 mt-1 border rounded-md focus:ring focus:ring-blue-200"
                value={field2}
                onChange={(e) => setField2(e.target.value)}
                placeholder={t("Enter additional field...")}
              />
            </div>

            {/* Additional Image Upload */}
            <div className="mb-4">
              <h3 className="text-sm font-medium text-gray-700 mb-2">{t("Upload CSV Image:")}</h3>
              <input
                type="file"
                accept="image/*"
                onChange={handleImageUpload}
                className="w-full p-2  rounded-md focus:ring focus:ring-blue-200"
              />
            </div>

            {/* ImageEditor Component for Upload & Placemarks */}
            <div className="mb-4">
              <h3 className="text-sm font-medium text-gray-700 mb-2">{t("Upload Your Area & Add Placemarks:")}</h3>
              <ImageEditor />
            </div>

            {/* Buttons */}
            <div className="flex justify-end space-x-4">
              <button
                onClick={closeModal}
                className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300"
              >
                {t("Cancel")}
              </button>
              <button
                onClick={() => {
                  // Check if user has uploaded image and added placemarks
                  // if (!uploadedImage) {
                  //   Swal.fire({
                  //     title: "Reminder!",
                  //     text: "Please press add image button to ensure Area Image is added",
                  //     icon: "warning",
                  //     confirmButtonText: "OK",
                  //   });
                  //   console.log("if: ", uploadedImage)
                  // } else {
                  closeModal();
                  //   console.log("else: ", uploadedImage)
                  // }
                }}
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
              >
                {t("Save")}
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="flex space-x-4 mb-4">
        <button
          onClick={handleDownloadPDF}
          className={`px-6 py-2 rounded-md shadow-md text-white ${isLoading ? "bg-gray-400 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700"
            }`}
          disabled={isLoading} // Disable button when loading
        >
          {isLoading ? (
            <div className="flex items-center">
              <svg
                className="animate-spin h-5 w-5 text-white mr-2"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v8H4z"
                ></path>
              </svg>
              {t("Loading...")}
            </div>
          ) : (
            <>
              {t("Download")}
            </>
          )}
        </button>
        <button
          onClick={openModal}
          className="px-6 py-2 bg-blue-600 text-white rounded-md shadow-md hover:bg-blue-700"
        >
          {i18n.language === "ur" ? "ان پٹ شامل کریں" : "Add Input"}
        </button>
      </div>

      {data.length > 0 ? (
        <div ref={reportRef}>
          <FarmReportContainer />
          {/* Static Section for summary & Weather APi */}
          <div
            style={{
              marginTop: "0.5rem",
              background: "linear-gradient(to bottom right, #d4edda, #c3e6cb)",
              width: "100%",
              padding: "1rem",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              overflowX: "hidden",
              overflowY: "auto",
            }}
          >
            <div
              style={{
                maxWidth: "40rem",
                margin: "0 auto",
                width: "60%",
                padding: "1.5rem",
                backgroundColor: "#fff",
                borderRadius: "0.5rem",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                pageBreakAfter: "always", // Forces a new page after each div
                breakAfter: "page", // Alternative property for better browser support
              }}
            >
              {/* Title */}
              <h2
                style={{
                  textAlign: "center",
                  fontSize: "1.5rem",
                  fontWeight: "bold",
                  marginBottom: "1.5rem",
                  color: "#155724",

                }}
              >
                {i18n.language === "ur" ? "موسمی خلاصہ" : "Weather Summary"}
              </h2>

              {/* Weather Summary */}
              <div style={{ marginBottom: "1.5rem" }}>

                {[
                  { label: i18n.language === "ur" ? "شبنم نقطہ" : "Dew Point", value: weather.dewpoint, unit: "°C" },
                  { label: i18n.language === "ur" ? " درجہ حرارت" : "Temp", value: weather.feelslike, unit: "°C" },
                  { label: i18n.language === "ur" ? "ہوا کی رفتار" : "Wind Speed", value: weather.wind_kph, unit: "kph" },
                  { label: i18n.language === "ur" ? "نمی" : "Humidity", value: weather.humidity, unit: "%" },
                  { label: i18n.language === "ur" ? "بارش" : "Precipitation", value: weather.preceip_mm, unit: "mm" },

                ].map(({ label, value, unit }) => (
                  <div key={label} style={{ display: "flex", justifyContent: "space-between", marginBottom: "1rem" }}>
                    <span style={{ fontWeight: "bold", color: "#555" }}>{label}:</span>
                    <span style={{ color: "#555" }}>
                      {`${value ?? "N/A"} ${unit}`}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <AgronomistInputContainer recommend={recommend} field2={field2} />
          <div
          >
            <p
              style={{
                fontSize: "1.25rem",
                fontWeight: "700",
                color: "#374151",
                marginTop: "0.5rem",
                textDecoration: "underline",
              }}
            >
              {i18n.language === "ur" ? "پیش گوئی کا ڈیٹا" : "Forecasting Data:"}
            </p>

            <div style={{ overflowX: "auto", padding: "1rem" }}>
              <table
                style={{
                  width: "100%",
                  fontSize: "0.9rem",
                  borderCollapse: "collapse",
                  backgroundColor: "#fff",
                  borderRadius: "8px",
                  overflow: "hidden",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                }}
              >
                <thead
                  style={{
                    backgroundColor: "#374151",
                    color: "#fff",
                    textAlign: "left",
                  }}
                >
                  <tr>
                    {[
                      i18n.language === "ur" ? "تاریخ" : "Date",
                      i18n.language === "ur" ? "درجہ حرارت" : "Temperature",
                      i18n.language === "ur" ? "بارش" : "Precipitation",
                      i18n.language === "ur" ? "ہوا" : "Wind",
                      i18n.language === "ur" ? "بارش کی مقدار" : "Rain",
                      i18n.language === "ur" ? "نمی" : "Humidity",
                      i18n.language === "ur" ? "موسمی صورتحال" : "Weather Status",
                    ].map((heading, index) => (
                      <th
                        key={index}
                        style={{
                          padding: "1rem",
                          fontWeight: "600",
                          textTransform: "uppercase",
                        }}
                      >
                        {heading}
                      </th>
                    ))}
                  </tr>

                </thead>
                <tbody>
                  {forecast?.map((day, index) => (
                    <tr
                      key={index}
                      style={{
                        backgroundColor: index % 2 === 0 ? "#f9fafb" : "#ffffff",
                        borderBottom: "1px solid #ddd",
                        transition: "background 0.3s",
                      }}
                      onMouseEnter={(e) => (e.currentTarget.style.background = "#e5e7eb")}
                      onMouseLeave={(e) =>
                      (e.currentTarget.style.background =
                        index % 2 === 0 ? "#f9fafb" : "#ffffff")
                      }
                    >
                      <td style={{ padding: "1rem", fontWeight: "500" }}>{day.date}</td>
                      <td style={{ padding: "1rem" }}>
                        {day.day.mintemp_c}°C - {day.day.maxtemp_c}°C
                      </td>
                      <td style={{ padding: "1rem" }}>{day.day.totalprecip_mm} mm</td>
                      <td style={{ padding: "1rem" }}>{day.day.maxwind_kph} kph ↑</td>
                      <td style={{ padding: "1rem" }}>{day.day.daily_chance_of_rain}%</td>
                      <td style={{ padding: "1rem" }}>{day.day.avghumidity}%</td>
                      <td
                        style={{
                          padding: "1rem",
                          fontWeight: "600",
                          color: "#374151",
                          textTransform: "capitalize",
                          display: "flex",
                          justifySelf: "center",
                          alignSelf: "center",
                        }}
                      >
                        {day.day.condition.text}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          
          {uploadedImage ? (
            <div style={{ marginBottom: "1rem", position: "relative", pageBreakAfter: "always", breakAfter: "page" }}>
              <div
                style={{
                  position: "absolute",
                  top: "1rem",          // closer to the top
                  right: "1rem",        // some spacing from edge
                  backgroundColor: "rgba(255, 255, 255, 0.9)",
                  padding: "0.75rem 1rem",
                  borderRadius: "0.5rem",
                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.15)",
                  display: "flex",
                  flexDirection: "column",
                  gap: "0.5rem",
                  width: "8rem",        // fixed width ensures consistency
                  zIndex: 10,           // always visible
                }}
              >
                {[
                  { icon: <Home size={18} />, label: "House" },
                  { icon: <Droplet size={18} />, label: "Water" },
                  { icon: <LandPlot size={18} />, label: "Soil" },
                  { icon: <WaypointsIcon size={18} />, label: "Road" },
                ].map(({ icon, label }) => (
                  <div
                    key={label}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end", // icon on right for RTL-like flow
                      gap: "0.4rem",
                      fontSize: "0.9rem",
                      color: "#374151",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <span>{label}</span>
                    {icon}
                  </div>
                ))}
              </div>
              <h3
                style={{
                  fontSize: "1.125rem",
                  fontWeight: "600",
                  color: "#374151",
                  marginTop: "0.5rem",
                  textDecoration: "underline",
                }}
              >
                {i18n.language === "ur" ? "آپ کا علاقہ" : "Your Area"}
              </h3>

              <img
                src={`${uploadedImage}?t=${Date.now()}`}
                alt="Uploaded"
                style={{
                  width: "900px",
                  height: "550px",
                  objectFit: "contain",
                }}
              />
            </div>
          ) : (
            <div>
              <p
                style={{
                  fontSize: "1.125rem",
                  fontWeight: "600",
                  color: "#374151",
                  marginTop: "0.5rem",
                  textDecoration: "underline",
                }}
              >{i18n.language === "ur" ? "آپ کا علاقہ" : "Your Area"}</p>
              <h1>
                {i18n.language === "ur"
                  ? "کوئی تصویر نہیں ملی۔ براہ کرم ایک اپلوڈ کریں۔"
                  : "No Image Found. Please Upload One"}
              </h1>
            </div>
          )}
          
          {/* Image Preview Section */}
          {previewURL ? (
            <div style={{ marginBottom: "1rem" }}>
              <h3 style={{
                fontSize: "1.125rem",
                fontWeight: "600",
                color: "#374151",
                marginTop: "0.5rem",
                textDecoration: "underline",
              }}>
                {i18n.language === "ur" ? "موبائل ڈیوائس ڈیٹا:" : "Mobile Device Data:"}
              </h3>
              <img
                src={previewURL}
                alt="Uploaded Preview"
                style={{
                  width: "900px",
                  height: "550px",
                  objectFit: "contain",
                  borderRadius: "0.5rem",
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)"
                }}
              />
            </div>
          ) : (
            <div>
              <p
                style={{
                  fontSize: "1.125rem",
                  fontWeight: "600",
                  color: "#374151",
                  marginTop: "0.5rem",
                  textDecoration: "underline",
                }}
              > {i18n.language === "ur" ? "موبائل ڈیوائس ڈیٹا:" : "Mobile Device Data:"}</p>
              <h1>Device number not assigned</h1>
            </div>
          )}

          {data.map((item, idx) => (
            <div
              key={idx}
              style={{
                marginBottom: "2rem",
                width: "100%",
                maxWidth: "80rem",
                pageBreakAfter: "always", // Forces a new page after each div
                breakAfter: "page", // Alternative property for better browser support
              }}
            >
              <h2
                style={{
                  fontSize: "1.25rem",
                  fontWeight: "bold",
                  marginBottom: "0.5rem",
                  color: "#4A5568", // Gray 800
                  textDecoration: "underline",
                }}
              >
                {item.title}
              </h2>
              <p
                style={{
                  marginBottom: "1rem",
                  color: "#718096", // Gray 600
                }}
              >
                {item.description}
              </p>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "1.5rem",
                }}
              >
                {item.images.map((img, imgIdx) => (
                  <div
                    key={imgIdx}
                    style={{
                      flex: 1,
                    }}
                  >
                    <h3
                      style={{
                        fontWeight: "600",
                        marginBottom: "0.5rem",
                        color: "#4A5568", // Gray 800
                      }}
                    >
                      {img.label}
                    </h3>
                    <img
                      src={img.url}
                      alt={`Image for ${img.label}`}
                      style={{
                        width: "100%",
                        maxHeight: "500px", // Limit vertical size
                        objectFit: "contain",
                        borderRadius: "0.375rem",
                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                        marginBottom: "1rem",
                        display: "block",
                        marginLeft: "auto",
                        marginRight: "auto",
                      }}
                    />

                    {item.levels.length > 0 && (
                      <div
                        style={{
                          border: "2px solid #E2E8F0", // Gray 200
                          padding: "1rem",
                          borderRadius: "0.375rem",
                        }}
                      >
                        <h4
                          style={{
                            fontWeight: "600",
                            marginBottom: "1rem",
                            color: "#4A5568", // Gray 800
                          }}
                        >
                          {i18n.language === "ur" ? "علامات:" : "Legend:"}
                        </h4>
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(auto-fit, minmax(8rem, 1fr))",
                            gap: "1rem",
                          }}
                        >
                          {item.levels.map((level, i) => (
                            <div
                              key={i}
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <div
                                style={{
                                  width: "1.5rem",
                                  height: "1.5rem",
                                  marginRight: "0.5rem",
                                  borderRadius: "50%",
                                  backgroundColor: item.colors[i],
                                }}
                              ></div>
                              <span
                                style={{
                                  color: "#4A5568", // Gray 700
                                }}
                              >
                                {level}
                              </span>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-gray-700">
          {date.a
            ? i18n.language === "ur"
              ? "منتخب کردہ تاریخ کے لیے ڈیٹا لوڈ ہو رہا ہے..."
              : "Data for the selected date is loading..."
            : i18n.language === "ur"
              ? "کوئی ڈیٹا دستیاب نہیں۔ براہ کرم رپورٹ بنانے کے لیے ایک تاریخ منتخب کریں۔"
              : "No data available. Please select a date to generate the report."
          }
        </p>
      )}
    </div>
  );
};

export default ReportVisualization;